import template from './template.html';
import controller from './controller';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider, $urlRouterProvider){

	$stateProvider.state('main.panel.notifications', {
		url: '/notifications',
		template: template,
		controller: controller,
		controllerAs: 'vm'

	});

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/notifications.component/routes.js
 **/